import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-hierarchy',
  templateUrl: './icon-hierarchy.component.html',
  styleUrls: ['./icon-hierarchy.component.scss']
})
export class IconHierarchyComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
